import { string, ValidationError } from 'yup';

export type IValidateValue = string | false;

const MIN_PHRASE_LENGTH = 4;
const MIN_PHONE_DIGITS = 10;
const MAX_PHONE_DIGITS = 11;
export const EMAIL_ERROR_MESSAGE = 'Неверный адрес электронной почты';
export const PHRASE_ERROR_MESSAGE = `Поле должно содержать не менее ${MIN_PHRASE_LENGTH} знаков`;
export const REQURED_MAIL_MESSAGE = 'Поле «Почта» должно быть заполнено';
export const REQURED_PHRASE_MESSAGE = 'Поле должно быть заполнено';
export const EMPTY_FIELD_MESSAGE = 'Не может быть пустым';

export const REQURED_LAT_MESSAGE = 'Поле содержит не допустимые символы';
export const REQURED_PHONE_MESSAGE = 'Номер телефона содержит не допустимые символы';
export const PHONE_LENGTH_ERROR_MESSAGE = `Номер телефона должен содержать ${MIN_PHONE_DIGITS} или ${MAX_PHONE_DIGITS} цифр`;

export const REGEX_LAT_SCHEMA = /^[0-9ёЁа-яА-Я-']+$/;

const REGEX_PHONE_BRACKETS = /\((\d{3})\)/;
const REGEX_PHONE_SCHEMA = /^\+?(?:\d{1,2}[\s-]?)?\d{3}[\s-]?\d{3}[\s-]?\d{2}[\s-]?\d{2}$/;
const REGEX_NON_DIGIT = /\D/g;

const isPhoneFormatValid = (phone: string) => REGEX_PHONE_SCHEMA.test(phone.replace(REGEX_PHONE_BRACKETS, '$1'));

const isPhoneDigitsCountValid = (phone: string) => {
  const digitsCount = phone.replace(REGEX_NON_DIGIT, '').length;
  return digitsCount >= MIN_PHONE_DIGITS && digitsCount <= MAX_PHONE_DIGITS;
};

export const emailValidator = async (eamil: string) => {
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(eamil)) {
    return EMAIL_ERROR_MESSAGE;
  }

  let resp: IValidateValue = false;
  const eamilSchema = string().default('').email(EMAIL_ERROR_MESSAGE).required(REQURED_MAIL_MESSAGE);
  try {
    await eamilSchema.validate(eamil);
  } catch (e) {
    if (e instanceof ValidationError) {
      resp = e.message;
    }
  }
  return resp;
};

export const phraseLatValidator = async (phrase: string) => {
  let resp: IValidateValue = false;
  const phraseSchema = string()
    .default('')
    .matches(REGEX_LAT_SCHEMA, REQURED_LAT_MESSAGE)
    .required(REQURED_PHRASE_MESSAGE)
    .min(MIN_PHRASE_LENGTH, PHRASE_ERROR_MESSAGE);
  try {
    await phraseSchema.validate(phrase);
  } catch (e) {
    if (e instanceof ValidationError) {
      resp = e.message;
    }
  }
  return resp;
};

export const phraseValidator = async (phrase: string) => {
  let resp: IValidateValue = false;
  const phraseSchema = string()
    .default('')
    .required(REQURED_PHRASE_MESSAGE)
    .min(MIN_PHRASE_LENGTH, PHRASE_ERROR_MESSAGE);
  try {
    await phraseSchema.validate(phrase);
  } catch (e) {
    if (e instanceof ValidationError) {
      resp = e.message;
    }
  }
  return resp;
};

export const phoneValidator = async (phrase: string) => {
  let resp: IValidateValue = false;
  const phraseSchema = string()
    .default('')
    .required(REQURED_PHRASE_MESSAGE)
    .test('phone-format', REQURED_PHONE_MESSAGE, (value) => isPhoneFormatValid(value ?? ''))
    .test('phone-digits-count', PHONE_LENGTH_ERROR_MESSAGE, (value) => isPhoneDigitsCountValid(value ?? ''));
  try {
    await phraseSchema.validate(phrase);
  } catch (e) {
    if (e instanceof ValidationError) {
      resp = e.message;
    }
  }
  return resp;
};
